import styled from 'styled-components';

export const ContainerItem = styled.div`
     width: 100%;
    /* cursor: pointer; */

    display: flex;
    flex-wrap: wrap;
    gap: 24px;

    & > div {
        /* pointer-events: none; */

        width: calc(50% - 24px);
        max-width: calc(50% - 24px);
    }
`;

export const DivItem = styled.div`

`;
